import { LoaderFunction } from "react-router-dom";
import { productsApi } from "src/api/services/productsApi";
import { store } from "src/api/store";

export const productLoader: LoaderFunction = ({ params }) => {
  if (params.productId != null) {
    return store
      .dispatch(productsApi.endpoints.getProduct.initiate(params.productId))
      .unwrap();
  }
};
